const nakiRadioContentType = {
    podcast: "podcast",
    station: "station",
    nakiNigun: "naki-nigun",
};

export default nakiRadioContentType;
